<template>
    <span>
        {{ Translations.sections.planning.sectionTitle }} - {{planningMonth.format("YYYY MMMM")}}
    </span>
</template>

<script>
    import Vue from 'vue';
    import Bootstrap from 'bootstrap-vue'
    import Translations from '@/store/translations';
    import { mapState } from 'vuex';
    import moment from "moment";

    Vue.use(Bootstrap);

    export default {
        name: "PlanningSectionHeader",
        components: {
        },
        computed: {
            Translations: () => Translations,
            ...mapState(["planningMonth"])
        },
        data() {
            return {}
        }
    }
</script>

<style scoped>
</style>